import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryVendorCreatePostBody, IInventoryVendorCreateReponse } from "@/api_framework/api_modals/Inventory";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useInventoryVendorCreateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (formBody: IInventoryVendorCreatePostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!accessToken) {
          throw new Error("Access token not found. Please log in again.");
        }

        let response: RotaCreationReturnType;

        try {
          const res = await axios.post<IInventoryVendorCreateReponse>(
            INVENTORY_MODULE?.VENDOR_ADD?.baseURL ?? "",
            formBody,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (res.data.status === true) {
            response = { status: true, message: "Updated" };
          } else {
            response = { status: false, message: "Vendor Updation Failed" };
          }
        } catch (e: AxiosError | any) {
          sendCurl(e.config?.curlCommand);

          captureError(e);

          response = { status: false, message: "Vendor Updation Failed" };
        }
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [], // Removed `dispatch`
  );

  return { execute };
};
